import type { shell as en } from '@/i18n/locales/en/shell';
import type { Translation } from '@/i18n/types';

export const shell: Translation<typeof en> = {
  notFound: {
    title: 'Η σελίδα δεν βρέθηκε',
    body: 'Αυτή η διεύθυνση δεν υπάρχει.',
    backLink: 'Επιστροφή στην επισκόπηση',
  },
  configWarning: {
    body: '<0>Ημιτελής διαμόρφωση.</0> Λείπει {{missing}}. Ρυθμίστε τα στο <1>.env.local</1> για τοπική ανάπτυξη (δείτε το <2>.env.example</2>), ή στο περιβάλλον του container για ανάπτυξη σε παραγωγή.',
  },
  skipToContent: 'Μετάβαση στο περιεχόμενο',
  brandName: 'NOLATR',
  mainNav: 'Κύριο',
  sectionNav: 'Ενότητα',
  accountNav: 'Λογαριασμός',
  openMainMenu: 'Άνοιγμα μενού',
  closeMainMenu: 'Κλείσιμο μενού',
  activeCompany: 'Ενεργή εταιρεία',
  profileStub: {
    title: 'Προφίλ',
    lead: 'Η σελίδα προφίλ σας έρχεται σύντομα — προς το παρόν αυτό είναι ένα προσωρινό στοιχείο ώστε το περιβάλλον να έχει πού να σας στείλει.',
  },
  manageStub: {
    title: 'Διαχείριση',
    lead: 'Επιλέξτε μια ενότητα από το μενού.',
  },
};
